export default __webpack_public_path__ + "static/media/civil-pert.cc3322c7.png";